import { useContext } from "react";
import AuthContext from "../../globalContext/context";

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;